import React, { useContext } from 'react'
import gql from 'graphql-tag'
import { DownloadCSVButton } from '../../../components/common/download-csv-button/DownloadCSVButton'
import { IOverviewFilter } from './UserActivityOverviewTable'
import { AnalyticsContext } from '../AnalyticsContext'
import { prepareCSVUserActivityExport } from './csv-user-activity'
import { UserDetailAnalyticsQuery } from 'front-end/src/pages/analytics/user-detail/UserDetailAnalytics.codegen'

export interface IUserActivityCsvResponse {
  viewsCount: number
  resourceName: string
  resourceId: number
  lastViewedAt: string
  deleted_at: Date | null
  lastViewedVersion: string
}

const csvQuery = gql`
  query (
    $mainAnalyticsFilter: AnalyticsFilterWithGroups!
    $overviewFilter: AnalyticsUserActivityFilter!
  ) {
    analytics(filter: $mainAnalyticsFilter) {
      resources {
        userActivityOverview(overviewFilter: $overviewFilter) {
          viewsCount
          resourceName
          resourceId
          lastViewedAt
          deleted_at
          lastViewedVersion
        }
      }
    }
  }
`

interface IUserActivityCSVProps {
  userActivityOverviewFilter: IOverviewFilter
  userActivityCount: number
  user: UserDetailAnalyticsQuery['user']
}

export const DownloadUserActivityCSV = ({
  userActivityOverviewFilter,
  userActivityCount,
  user
}: IUserActivityCSVProps) => {
  const { filterAsQueryVariables } = useContext(AnalyticsContext)

  return (
    <DownloadCSVButton
      count={userActivityCount}
      fileName={'looop-user-activity'}
      dataPath={'data.analytics.resources.userActivityOverview'}
      queryOptions={(page, limit) => ({
        variables: {
          mainAnalyticsFilter: filterAsQueryVariables,
          overviewFilter: {
            ...userActivityOverviewFilter,
            page,
            limit
          }
        },
        query: csvQuery,
        fetchPolicy: 'no-cache'
      })}
      prepareData={(rowData) => {
        return prepareCSVUserActivityExport(rowData, user)
      }}
    />
  )
}
